import CommonUiModel from "../common/commonUiModel";

const MasterScopeScreen = new CommonUiModel({
  title: "ScopeModel",
  customAddText: "Add Scope Master",
  relations: ["Document"],
  gridTitle: 'Scope Master',
  overrideFileName: "Master Scope",
  formTitle: "Add Scope",
  linkColumn: 'ScopeModel',
  module: 'ScopeMaster',
  tableName: 'ScopeModel',
  columns: [
    { field: 'ManufacturerId', label: 'Manufacturer', type: 'select', width: 150, required: true, lookup: 'Manufacturer', selectField: 'ManufacturerId', dataIndex: "Manufacturers" },
    { field: 'ScopeTypeId', label: 'Scope Type', type: 'select', width: 150, required: true, lookup: 'ScopeType', dataIndex: "ScopeType" },
    { field: 'ScopeModel', label: 'Scope Model', max: 50, required: true },
    { field: 'Channels', label: 'Channels', type: 'number', width: 100, min: 0, max: 7 },
    { field: 'Series', label: 'Series', type: 'string'},
    { field: 'SoldIn', label: 'Sold In (Required for enspire 3000)', type: 'select', width: 200, lookup: 'SoldInRegion' },
    { field: 'WorkingLength', label: 'Working Length(mm)', type: 'string', width: 150, minValue: 0 },
    { field: 'RepresentativeScope', label: 'Rep Scope', type: 'string', width: 150, hide: true },
    { field: 'StatusId', label: 'Status', type: 'select', width: 150, lookup: 'ScopeStatus', required: true },
    { field: 'Notes', label: 'Notes', multiline: true, min: 3 },
    { field: "ScopeModelAlias", label: "Alias", type: "chipInput", required: false, lookup: 'scopeModelAlias', width: 300, hasDefault: true, skipCopy: true, disabled: ({ isAdd }) => { return isAdd; }, dataFormat: "array"}
  ]
});
export default MasterScopeScreen;
